import { useState, useEffect } from 'react';
import { ticketApi } from '../../api/ticket.api';
import { useUI } from '../../store/UIContext';

const DEFAULT_TEXT = 'وضعیت تیکت شما به‌روزرسانی شد. لطفا مجددا چک کنید';

// Employee-only manual SMS panel on the ticket-response page - separate
// from the automatic "your ticket was answered" SMS the backend already
// sends on first response, this lets the employee text the customer at any
// point while working the ticket (e.g. mid-conversation status nudges).
export default function TicketSmsPanel({ ticketId }) {
  const { addToast } = useUI();
  const [target, setTarget] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [message, setMessage] = useState(DEFAULT_TEXT);
  const [sending, setSending] = useState(false);
  const [sentAt, setSentAt] = useState(null);

  useEffect(() => {
    if (!ticketId) return;
    ticketApi.getTicketSmsTarget(ticketId)
      .then((res) => setTarget(res.data?.phone_number ? res.data : null))
      .catch(() => setTarget(null))
      .finally(() => setLoaded(true));
  }, [ticketId]);

  const send = async () => {
    if (!message.trim()) {
      addToast('متن پیامک را وارد کنید', 'error');
      return;
    }
    setSending(true);
    try {
      await ticketApi.sendTicketSms(ticketId, message.trim());
      addToast('پیامک ارسال شد', 'success');
      setSentAt(new Date());
    } catch (e) {
      addToast(e.response?.data?.error || 'خطا در ارسال پیامک', 'error');
    } finally {
      setSending(false);
    }
  };

  if (!loaded || !target) return null;

  return (
    <div style={{ background: '#fff', borderRadius: 16, border: '1px solid rgba(35,58,122,0.1)', padding: 20 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#334155', marginBottom: 10 }}>
        📩 ارسال پیامک به {target.username || 'مشتری'} ({target.phone_number})
      </div>
      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={3}
        style={{ width: '100%', padding: '8px 12px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 13, outline: 'none', fontFamily: 'inherit', resize: 'vertical', marginBottom: 10, boxSizing: 'border-box' }}
      />
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <button
          onClick={send}
          disabled={sending}
          style={{
            padding: '8px 18px', borderRadius: 8, border: 'none', background: '#29AAE1', color: '#fff',
            fontSize: 12, fontWeight: 700, cursor: sending ? 'default' : 'pointer', opacity: sending ? 0.7 : 1, fontFamily: 'inherit',
          }}
        >
          {sending ? 'در حال ارسال...' : 'ارسال پیامک'}
        </button>
        {message !== DEFAULT_TEXT && (
          <button
            onClick={() => setMessage(DEFAULT_TEXT)}
            style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit' }}
          >
            بازگشت به متن پیش‌فرض
          </button>
        )}
        {sentAt && <span style={{ fontSize: 11, color: '#16a34a' }}>✓ آخرین ارسال موفق</span>}
      </div>
    </div>
  );
}
